
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    bg: {
      type: String,
      default: 'bg-gradient-to-tr from-[#122b4d] to-[#0b1423]',
    },
  },
  setup() {},
});
